import React from "react";
import { PuzzleMode } from "../../game/usePuzzleStore";

interface ModeSelectorProps {
  currentMode: PuzzleMode;
  onSelect: (mode: PuzzleMode) => void;
  disabled?: boolean;
}

const MODE_LABELS: Record<PuzzleMode, string> = {
  axis: "Axis Mode",
  classic: "Classic Mode"
};

const MODE_DESCRIPTIONS: Record<PuzzleMode, string> = {
  axis: "Swap pieces using movable axes",
  classic: "Drag and drop pieces like a jigsaw"
};

export const ModeSelector: React.FC<ModeSelectorProps> = ({
  currentMode,
  onSelect,
  disabled = false
}) => {
  const modes: PuzzleMode[] = ["axis", "classic"];

  return (
    <div
      className="stack-v stack-v--gap-xs"
      role="group"
      aria-label="Puzzle mode selection"
    >
      <div className="stack-h stack-h--gap-sm" style={{ alignItems: "center", flexWrap: "wrap" }}>
        <span className="text-xs text-muted" style={{ marginRight: "0.25rem" }}>
          Mode:
        </span>
        {modes.map((mode) => (
          <button
            key={mode}
            type="button"
            onClick={() => !disabled && onSelect(mode)}
            disabled={disabled}
            className={`btn ${currentMode === mode ? "btn--primary" : "btn--ghost"}`}
            style={{
              fontSize: "0.75rem",
              padding: "0.35rem 0.65rem",
              minWidth: "auto"
            }}
            aria-pressed={currentMode === mode}
          >
            {MODE_LABELS[mode]}
          </button>
        ))}
      </div>
      <div className="text-xs text-muted" style={{ fontSize: "0.7rem", marginTop: "0.1rem" }}>
        {MODE_DESCRIPTIONS[currentMode]}
      </div>
    </div>
  );
};

